var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppSidebar",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showSidebar,
          expression: "showSidebar"
        }
      ],
      staticClass: "has-preview",
      attrs: {
        title: _vm.sidebarStation.name,
        subtitle: _vm.stationTags,
        background: _vm.sidebarStation.favicon
      },
      on: { close: _vm.toggleSidebar }
    },
    [
      _c("div", { staticClass: "configBox" }, [
        _c("span", { staticClass: "icon icon-link" }),
        _vm._v(" "),
        _c("span", { staticClass: "title" }, [
          _vm._v("\n\t\t\t" + _vm._s(_vm.t("radio", "Stream URL")) + "\n\t\t")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("input", {
              attrs: { type: "text", disabled: "disabled" },
              domProps: { value: _vm.urlResolved }
            }),
            _vm._v(" "),
            _c(
              "Actions",
              [
                _c(
                  "ActionButton",
                  {
                    attrs: { icon: "icon-clippy" },
                    on: { click: _vm.copyLink }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.t("radio", "Copy link to clipboard")) +
                        "\n\t\t\t\t"
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "configBox" }, [
        _c("span", { staticClass: "icon icon-external" }),
        _vm._v(" "),
        _c("span", { staticClass: "title" }, [
          _vm._v("\n\t\t\t" + _vm._s(_vm.t("radio", "Homepage")) + "\n\t\t")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("span", [
            _c(
              "a",
              { attrs: { href: _vm.sidebarStation.homepage, target: "new" } },
              [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.sidebarStation.homepage) +
                    "\n\t\t\t\t"
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "configBox" }, [
        _c("span", { staticClass: "icon icon-details" }),
        _vm._v(" "),
        _c("span", { staticClass: "title" }, [
          _vm._v(
            "\n\t\t\t" + _vm._s(_vm.t("radio", "Country & Language")) + "\n\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("span", [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(_vm.sidebarStation.country) +
                ", " +
                _vm._s(_vm.sidebarStation.language) +
                "\n\t\t\t"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "configBox" }, [
        _c("span", { staticClass: "icon icon-details" }),
        _vm._v(" "),
        _c("span", { staticClass: "title" }, [
          _vm._v(
            "\n\t\t\t" + _vm._s(_vm.t("radio", "Codec & Bitrate")) + "\n\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("span", [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(_vm.sidebarStation.codec) +
                ", " +
                _vm._s(_vm.sidebarStation.bitrate) +
                "\n\t\t\t"
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }